import { mergeMap } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { asyncScheduler, concat, Observable, of, scheduled } from 'rxjs';
import { Actions } from 'src/core/state/user';

import { Msg } from '../cart.actions';

/**
 * Listen for the user signing out
 *
 * When that happens, clear any existing data + refresh
 *
 * @param action$
 */
export function userSignedOutReaction(action$: Observable<any>) {
    return action$.pipe(
        ofType<Actions>('User.SignOut'),
        mergeMap(() => {
            return concat(of(Msg('Cart.Reset')), scheduled(of(Msg('Cart.Refresh', { force: true })), asyncScheduler));
        }),
    );
}
